import * as React from "react";
import { useState } from "react";
import { Avatar, Menu, MenuItem } from "@mui/material";
import { grey } from "@mui/material/colors";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getNameInitials, getUserData, userLogout } from "../../Helpers/utils";
import { useNavigate } from "react-router-dom";
import { NewsHandlesContainer } from "../news/newsHandles";
import { UserAuthData } from "../../Helpers/backendResponseInterfaces";
import { JumpIN } from "../utils/buttons";

interface UserMenuItem {
  name: string;
  onClick: (navigate: any) => void; // Adjust as per your navigation type
}

const userDropDown: UserMenuItem[] = [
  {
    name: "Logout",
    onClick: (navigateUrl) => {
      userLogout();
      navigateUrl("/jumpin");
    },
  },
];

interface UserMenuProps {
  user: UserAuthData | null; // Adjust as per your user data type
}

const UserMenu: React.FC<UserMenuProps> = ({ user }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div
        className="flex justify-end w-full gap-1 items-center"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: grey[300] }}>
          {getNameInitials(user ? user.user.name : "NA")}
        </Avatar>
        <ArrowDropDownIcon />
      </div>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        {userDropDown.map((item) => (
          <MenuItem key={item.name} onClick={() => item.onClick(navigate)}>
            {item.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const SidePane: React.FC = () => {
  const user = getUserData();

  return (
    <div className="flex flex-col justify-start min-w-full min-h-screen p-6 gap-5">
      {user ? <UserMenu user={user} /> : <JumpIN />}
      <div className="basis-9/12 flex flex-col justify-center max-h-full">
        <NewsHandlesContainer />
      </div>
    </div>
  );
};

export default SidePane;
